import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.jsx';
import './styles.css';

createRoot(document.getElementById('root')).render(
  <BrowserRouter basename={import.meta.env.VITE_BASE || undefined}>
    <App />
  </BrowserRouter>
);
